import { useEffect, useState } from "react";
import { StoreProvider, useStore } from "./data/store";
import { ToastProvider } from "./ui/Toast";
import { EntitlementProvider } from "./data/entitlement";
import { Today } from "./screens/Today";
import { Habits } from "./screens/Habits";
import { Mind } from "./screens/Mind";
import { Night } from "./screens/Night";
import { Settings } from "./screens/Settings";
import { initTelegram, haptic } from "./platform/telegram";

type Tab = "today" | "habits" | "mind" | "night" | "me";

const TABS: Array<{ id: Tab; label: string; icon: string }> = [
  { id: "today",  label: "امروز",   icon: "☀️" },
  { id: "habits", label: "عادت‌ها", icon: "🌱" },
  { id: "mind",   label: "ذهنم",    icon: "🧠" },
  { id: "night",  label: "قبل خواب", icon: "🌙" },
  { id: "me",     label: "من",      icon: "⭐" },
];

function Shell() {
  const { ready, state } = useStore();
  const [tab, setTab] = useState<Tab>("today");

  // تنظیم «کاهش حرکت» کاربر بر تنظیم سیستم اولویت دارد
  useEffect(() => {
    document.documentElement.dataset.reduceMotion = state.settings?.reduceMotion ? "1" : "0";
  }, [state.settings?.reduceMotion]);

  if (!ready) {
    return (
      <div className="boot">
        <span className="boot-star">⭐</span>
        <p>ستاره سهیل</p>
      </div>
    );
  }

  return (
    <div className="app">
      <main className="main">
        {tab === "today"  && <Today />}
        {tab === "habits" && <Habits />}
        {tab === "mind"   && <Mind />}
        {tab === "night"  && <Night />}
        {tab === "me"     && <Settings />}
      </main>

      <nav className="tabs" aria-label="بخش‌های اپ">
        {TABS.map((t) => (
          <button
            key={t.id}
            data-on={tab === t.id ? "1" : "0"}
            aria-current={tab === t.id ? "page" : undefined}
            onClick={() => { haptic("select"); setTab(t.id); }}
          >
            <span aria-hidden="true">{t.icon}</span>
            <em>{t.label}</em>
          </button>
        ))}
      </nav>
    </div>
  );
}

export default function App() {
  useEffect(() => { initTelegram(); }, []);
  return (
    <StoreProvider>
      <EntitlementProvider>
        <ToastProvider>
          <Shell />
        </ToastProvider>
      </EntitlementProvider>
    </StoreProvider>
  );
}
